import { Component, OnDestroy } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { PlatformSettings } from 'src/app/constants/settings.enum';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { Subscription } from 'rxjs';
import { OrganisationSettingsApiClient } from 'src/app/services/organisation-settings.apiclient';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';

@Component({
  templateUrl: './email.page.html',
  styleUrls: ['./email.page.css']
})
export class EmailPage implements OnDestroy {
  orgSettings: any;
  currentUrl: any[] = [];
  hours: number[] = [12, 24, 36, 48, 60, 72, 94, 96];
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private settingsService: SettingsService, private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient, private organisationSettingsApiClient: OrganisationSettingsApiClient, private organisationApiClient: OrganisationApiClient) {
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      if (organisationId === this.selectedOrganisationId) return;
      this.selectedOrganisationId = organisationId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Application(this.selectedOrganisationId), BreadCrumbOptions.Application_Email(this.selectedOrganisationId));

      this.getEmailSettings();
    });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  async getEmailSettings() {
    let sendingRequestSettings: PlatformSettings[] = [
      PlatformSettings.OrganisationLanguage,
      PlatformSettings.EmailSender,
      PlatformSettings.ShowRecentlyContacts,
      PlatformSettings.SigningNote,
      PlatformSettings.EmailInviteReminderSchedule,
      PlatformSettings.EmailOwnerDocumentReminderSchedule,
      PlatformSettings.EmailOwnerDigipoortStatus,
      PlatformSettings.EmailOwnerDocumentExpires,
      PlatformSettings.EmailOwnerSignDone,
      PlatformSettings.EmailOwnerSignReminder,
      PlatformSettings.EmailSignerExSignReminder,
      PlatformSettings.EmailSignerIDigipoortStatus,
      PlatformSettings.EmailSignerISignDone,
      PlatformSettings.EmailSignerISignReminder,
      PlatformSettings.EmailOwnerSignExpired
    ];

    this.organisationApiClient.getOrganisationSettingsByFilter(this.selectedOrganisationId, sendingRequestSettings).subscribe({
      next: (settings: any) => {
        let returnObject: any = {};
        settings.forEach((setting: any) => {
          returnObject[setting.key] = setting.value;
        });
        if (returnObject.OrganisationLanguage == undefined || returnObject.OrganisationLanguage == "") returnObject.OrganisationLanguage = "nl";
        if (returnObject.EmailSender == undefined || returnObject.EmailSender == "") returnObject.EmailSender = "Organisation";
        if (returnObject.ShowRecentlyContacts == undefined || returnObject.ShowRecentlyContacts == "") returnObject.ShowRecentlyContacts = "OrganisationLevel";
        if (returnObject.SigningNote == undefined || returnObject.SigningNote == "" || returnObject.SigningNote == "false") returnObject.SigningNote = false;
        else returnObject.SigningNote = true;

        returnObject.EmailInviteReminderSchedule = (returnObject.EmailInviteReminderSchedule == undefined || returnObject.EmailInviteReminderSchedule == "") ? 48 : JSON.parse(returnObject.EmailInviteReminderSchedule);
        returnObject.EmailOwnerDocumentReminderSchedule = (returnObject.EmailOwnerDocumentReminderSchedule == undefined || returnObject.EmailOwnerDocumentReminderSchedule == "") ? 24 : JSON.parse(returnObject.EmailOwnerDocumentReminderSchedule);;
        returnObject.EmailOwnerDigipoortStatus = (returnObject.EmailOwnerDigipoortStatus == undefined || returnObject.EmailOwnerDigipoortStatus == "" || returnObject.EmailOwnerDigipoortStatus == "false") ? false : true;
        returnObject.EmailOwnerDocumentExpires = (returnObject.EmailOwnerDocumentExpires == undefined || returnObject.EmailOwnerDocumentExpires == "" || returnObject.EmailOwnerDocumentExpires == "false") ? false : true;
        returnObject.EmailOwnerSignDone = (returnObject.EmailOwnerSignDone == undefined || returnObject.EmailOwnerSignDone == "" || returnObject.EmailOwnerSignDone == "false") ? false : true;
        returnObject.EmailOwnerSignReminder = (returnObject.EmailOwnerSignReminder == undefined || returnObject.EmailOwnerSignReminder == "" || returnObject.EmailOwnerSignReminder == "false") ? false : true;
        returnObject.EmailSignerExSignReminder = (returnObject.EmailSignerExSignReminder == undefined || returnObject.EmailSignerExSignReminder == "" || returnObject.EmailSignerExSignReminder == "false") ? false : true;
        returnObject.EmailSignerIDigipoortStatus = (returnObject.EmailSignerIDigipoortStatus == undefined || returnObject.EmailSignerIDigipoortStatus == "" || returnObject.EmailSignerIDigipoortStatus == "false") ? false : true;
        returnObject.EmailSignerISignDone = (returnObject.EmailSignerISignDone == undefined || returnObject.EmailSignerISignDone == "" || returnObject.EmailSignerISignDone == "false") ? false : true;
        returnObject.EmailSignerISignReminder = (returnObject.EmailSignerISignReminder == undefined || returnObject.EmailSignerISignReminder == "" || returnObject.EmailSignerISignReminder == "false") ? false : true;
        returnObject.EmailOwnerSignExpired = (returnObject.EmailOwnerSignExpired == undefined || returnObject.EmailOwnerSignExpired == "" || returnObject.EmailOwnerSignExpired == "false") ? false : true;
        returnObject.EmailOwnerActionCompleted = (returnObject.EmailOwnerActionCompleted == undefined || returnObject.EmailOwnerActionCompleted == "" || returnObject.EmailOwnerActionCompleted == "false") ? false : true;
        returnObject.EmailSignerIActionCompleted = (returnObject.EmailSignerIActionCompleted == undefined || returnObject.EmailSignerIActionCompleted == "" || returnObject.EmailSignerIActionCompleted == "false") ? false : true;
        returnObject.EmailSignerExActionCompleted = (returnObject.EmailSignerExActionCompleted == undefined || returnObject.EmailSignerExActionCompleted == "" || returnObject.EmailSignerExActionCompleted == "false") ? false : true;
        returnObject.EmailOwnerRequestPurged = (returnObject.EmailOwnerRequestPurged == undefined || returnObject.EmailOwnerRequestPurged == "" || returnObject.EmailOwnerRequestPurged == "false") ? false : true;
        returnObject.EmailOwnerActionFailed = (returnObject.EmailOwnerActionFailed == undefined || returnObject.EmailOwnerActionFailed == "" || returnObject.EmailOwnerActionFailed == "false") ? false : true;

        this.orgSettings = returnObject;
      }
    });
  }

  updateValue(key: string, value: string) {
    this.orgSettings[key] = value;
    this.settingsService.updateSettings([{ key: key, value: value }], this.selectedOrganisationId);
  }

  updateValueFromSwitch(event: any, key: string) {
    this.orgSettings[key] = (event.target as HTMLInputElement).checked;
    this.settingsService.updateSettings([{ key: key, value: this.orgSettings[key] }], this.selectedOrganisationId);
  }

  toggleChanged(event: any) {
    let key: string = (event.target as HTMLInputElement).id;
    let checked: boolean = (event.target as HTMLInputElement).checked;
    this.orgSettings[key] = checked;
    this.settingsService.updateSettings([{ key: key, value: this.orgSettings[key] }], this.selectedOrganisationId);
  }

  updateNotificationFrequenceValue(event: any) {
    let key: string = (event.target as HTMLInputElement).id;
    let hours: string = (event.target as HTMLInputElement).value;
    this.orgSettings[key] = hours;
    this.settingsService.updateSettings([{ key: key, value: this.orgSettings[key] }], this.selectedOrganisationId);
  }
}
